import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist';
import { productGetters, sellpointGetters, cartGetters } from './getters'
import { productMutations, sellpointMutations, cartMutations} from './mutations'
import { productActions, sellpointActions} from './actions'

Vue.use(Vuex)
const vuexLocalStorage = new VuexPersist({
    key: 'vuex', // The key to store the state on in the storage provider.
    storage: window.localStorage, // or window.sessionStorage or localForage
    // Function that passes the state and returns the state with only the objects you want to store.
    // reducer: state => state,
    reducer: state => ({
        cart: state.cart,
       // keepThisModuleToo: state.keepThisModuleToo
        // getRidOfThisModule: state.getRidOfThisModule (No one likes it.)
      })
    // Function that passes a mutation and lets you decide if it should update the state in localStorage.
    // filter: mutation => (true)
  })
  

export default new Vuex.Store({
    strict: true,
    plugins: [vuexLocalStorage.plugin],
    state: {
        //all users
        //users: [],
        //all sellpoints
        sellpoints: [],
        //a sellpoint
        sellpoint: {},
        //all products
        products: [],
        //a product
        product: {},
        // bought items
        cart: [],
        // ajax loader
        showLoader: false,
    },
    // GETTERS
    getters: Object.assign({}, productGetters, sellpointGetters, cartGetters),
    mutations: Object.assign({}, productMutations, sellpointMutations, cartMutations),
    actions: Object.assign({}, productActions, sellpointActions)
})


// WEBPACK FOOTER //
// ./src/store/index.js